module.exports = __webpack_public_path__ + "img/createLog.6e847736.png";